// @flow
import { Map } from "immutable";

export const allRatesSelector = (state: Map<string, any>) => {
  return state.getIn(["rate", "rates"]);
};
export const rateErrorSelector = (state: Map<string, any>) => {
  return state.getIn(["rate", "error"]);
};



// WEBPACK FOOTER //
// ./src/features/rate/store/rateSelectors.js